export const sortWithNull = (
    a: number | null,
    b: number | null,
    ascending: boolean = true
) => {
    if (a === b) {
        return 0
    }

    if (a === null) {
        return 1
    }

    if (b === null) {
        return -1
    }

    if (ascending) {
        return a < b ? -1 : 1
    }

    return a < b ? 1 : -1
}
